// extracted by mini-css-extract-plugin
module.exports = {"container":"UIBlocker_container__2gRNH","transparent":"UIBlocker_transparent__3zVto","icon":"UIBlocker_icon__3wFMZ"};